import { Paper, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface ManifestPartyCardProps {
  title: string;
  /** Small leading icon for the card header. */
  icon: ReactNode;
  children: ReactNode;
}

/**
 * A bordered card grouping one party's fields (Generator or Receiving TSDF) into
 * a self-contained block, so related data reads as a unit instead of bleeding
 * across a shared column grid.
 */
export function ManifestPartyCard({ title, icon, children }: ManifestPartyCardProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        borderRadius: 2,
        p: 2,
        flex: 1,
        minWidth: 0,
        // One step lighter than the section card (grey[100]/grey[800]) — a gray,
        // not white — so the nested party blocks read as distinct.
        backgroundColor: (theme) =>
          theme.palette.mode === "light" ? theme.palette.grey[50] : theme.palette.grey[700],
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ mb: 1.5, color: "text.primary" }}
      >
        {icon}
        <Typography
          variant="subtitle2"
          color="text.primary"
          sx={{ fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em" }}
        >
          {title}
        </Typography>
      </Stack>
      {children}
    </Paper>
  );
}
